import type { FaireProductEntity } from "../../entity_types/product";

export const p_eu7d23u6sg: FaireProductEntity = {
  token: "p_eu7d23u6sg",
  type: "product",
  name: "Migraine + Headache",
  brandToken: "b_63rejl12p8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/3f2d9a6d4dc9ea18baf3fbe0f024a0ffdfd6805e980c5b54d260397e8c19cd03.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/876b922e9110e64f189f9399a5af2155b5e5ae6cfe07d923f4cd79dbb8ad564d.jpeg",
    "https://cdn.faire.com/fastly/7e2ecefdb2f3f8123c2446474c02eafabd515bff5a1fcc2f1bbfb3a97e4977e3.png",
    "https://cdn.faire.com/fastly/5549ed80d9c4ac6bc8f02cc36454426fc934d97a212cbfb9bf5528fabce05fc0.png",
  ],
  priceDollars: 7.59,
  description:
    "Forces of Nature Migraine + Headache is a topical, plant-based remedy design to fight headache and migraine symptoms including throbbing, pulsing sensations, nausea, and sensitivity to light and sound. Formulated with powerful organic homeopathic actives, including Iris Versicolor (Northern Blue Flag), believed to offer relief through its anti-inflammatory and soothing effects, this roll-on oil should be massaged into temples and the back of the neck at the first signs of a migraine. The active ingredients are blended into pure essential oils, including Lavandin and Roman Chamomile, to soothe and facilitate deep absorption. Unlike common OTC migraine treatments that rely on chemicals to mask symptoms, our certified organic formula helps restore balance naturally without synthetic drugs or anything to ingest. Safe for everyday use.\n\nCertified Organic, Non-GMO Project Verified, and Leaping Bunny certified, Migraine sets a higher standard for pain management with a clean, entirely natural formula. Tough on pain with a homeopathic approach that works with your body, get the relief you need without compromising your preference for natural remedies.",
  tags: [],
  msrpDollars: 15.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:34.179Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
